// Centralized utility text for use throughout the site.

export enum UtilityText {
	permissionTooltip = 'Additional permissions are needed to use this feature, please request access from your administrator.',
	tryAgainMsg = 'Something went wrong, Please try again.',
	somethingWrongMsg = 'Something went wrong.',
	pageLoadingTrouble = 'We’re having difficulty loading this page at the moment.',
}
